import { useEffect, useState } from 'react';
import { ClickAwayListener, FormControl, OutlinedInput } from '@material-ui/core';
import { trim } from 'lodash';
import PropTypes from 'prop-types';
import { useSlateSelection, useSlateStatic } from 'slate-react';

import { getEditorSelectedLinkNode } from 'src/lib/slate';

import { useSelectionDomRange, useSetupLinkPopupFloating } from '../../lib';
import { insertLink } from '../../utils';

import { useStyles } from './useStyles';

export const LinkEditPopup = ({ onClose }) => {
  const styles = useStyles();

  const [value, setValue] = useState('');
  const editor = useSlateStatic();
  const selection = useSlateSelection();

  const [floatingElement, setFloatingElement] = useState(null);
  const selectionDomRange = useSelectionDomRange();
  const expandedDomRange =
    selectionDomRange && !selectionDomRange.collapsed ? selectionDomRange : null;

  useEffect(() => {
    if (!expandedDomRange) {
      onClose();
      return;
    }

    // Find the current URL value
    const linkNode = getEditorSelectedLinkNode(editor);
    setValue(linkNode?.url || '');
  }, [editor, selection, onClose, expandedDomRange]);

  const { floatingStyles, isPositioned } = useSetupLinkPopupFloating(
    floatingElement,
    expandedDomRange
  );

  const handleEnterPress = (event) => {
    if (event.key === 'Enter' && !!trim(value)) {
      editor.restoreSelectionFromPrevious();
      insertLink(editor, value);
      onClose();
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  if (!expandedDomRange) {
    return null;
  }

  return (
    <ClickAwayListener
      onClickAway={onClose}
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
    >
      <FormControl
        className={styles.root}
        ref={setFloatingElement}
        style={floatingStyles}
      >
        {/* Render input only after "floating-ui" finished positioning, so `autoFocus` won't be causing any scroll events in parent Editor */}
        {isPositioned && (
          <OutlinedInput
            className={styles.input}
            value={value}
            onChange={handleChange}
            placeholder="Insert a URL"
            onKeyDown={handleEnterPress}
            autoFocus
          />
        )}
      </FormControl>
    </ClickAwayListener>
  );
};

LinkEditPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
};
